import Add from "@mui/icons-material/Add";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled, { css } from "styled-components";
import aiStarsIcon from "../../Media/Stars.svg";
import { HXButton, HXIconButton } from "../HXButton";
import { HXPageTitleText, Text, SemiBoldText, Subtitle, BoldText, LightSemiBoldText } from "../HXDesktopPage.styles";
import { HXCheckbox, HXTextField, withExplicitProps } from "../base.styles";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv, FlexRowSpaceBetween } from "../common.styles";
import RadioGroup from "@mui/material/RadioGroup";
import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import IconButton from "@mui/material/IconButton";
import { HXRadioButton } from "../base.styles";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import alertDangerIcon from "../../Media/alert-danger-large.svg";
import FormControlLabel from "@mui/material/FormControlLabel";
import ChevronRight from "@mui/icons-material/ChevronRight";
import CalendarToday from "@mui/icons-material/CalendarToday";
import InputAdornment from "@mui/material/InputAdornment";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import Lock from "@mui/icons-material/Lock";
import Chip from "@mui/material/Chip";
import Edit from "@mui/icons-material/Edit";
import { ScrollElement } from "react-scroll";
export const addStudySectionProgressBorderWidth = 2;
const contentMaxWidth = "926px";
export const AddJoinCommonParent = styled(FlexColumn) `
    gap: 32px;
    width: ${contentMaxWidth};
    padding: 40px 80px 40px 40px;
    ${({ centerAligned }) => centerAligned &&
    `
            margin: auto 0;
        `}
`;
export const AddJoinCommonSectionCompleteIconContainer = styled(FlexColumnDiv) `
    width: ${(props) => (props.size === "LARGE" ? 32 : 24)}px;
    height: ${(props) => (props.size === "LARGE" ? 32 : 24)}px;
    align-items: center;
    justify-content: center;
    background: ${colors.forest_main};
    border-radius: 100px;
`;
export const AddJoinCommonSectionCompleteCheckIcon = styled(Check) `
    width: ${(props) => (props.size === "LARGE" ? 26.667 : 20)}px;
    height: ${(props) => (props.size === "LARGE" ? 26.667 : 20)}px;
    color: ${colors.white_main};
`;
export const AddJoinCommonSectionProgressContainer = styled.div `
    position: relative;
    z-index: 0;
    outline-color: ${colors.navy_8};
    outline-style: solid;
    outline-width: ${addStudySectionProgressBorderWidth}px;
    outline-offset: -${addStudySectionProgressBorderWidth}px;
    border-radius: 100px;
    width: ${(props) => (props.size === "LARGE" ? 32 : 24)}px;
    height: ${(props) => (props.size === "LARGE" ? 32 : 24)}px;
`;
export const AddJoinCommonSectionCircularProgress = styled(CircularProgress).attrs({ variant: "determinate" }) `
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    color: ${colors.navy_main};
`;
export const AddJoinCommonSectionProgressText = styled(SemiBoldText) `
    position: absolute;
    left: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    color: ${colors.navy_main};

    ${(props) => props.size === "SMALL" &&
    css `
            font-size: ${fontSizes.TINY};
            letter-spacing: 0.113px;
        `}
`;
export const AddJoinCommonTitle = styled(HXPageTitleText) `
    color: ${colors.black_main};

    ${(props) => props.addPaddingBottom &&
    css `
            padding-bottom: 24px;
        `}
`;
export const AddJoinCommonSubtitle = styled(Subtitle) `
    padding-top: 8px;
`;
export const AddJoinCommonSubHeadingText = styled(Subtitle) `
    color: ${colors.black_light};
    font-weight: ${fontWeights.NORMAL};
`;
export const AddJoinCommonBannerContainer = styled(FlexColumn) `
    padding: 16px;
    gap: 12px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid ${colors.sunset_main};
    background: ${colors.sunset_8};
`;
export const AddJoinCommonLearnMoreContainer = styled(FlexColumn) ``;
export const AddJoinCommonErrorBannerContainer = styled(AddJoinCommonBannerContainer) `
    border: 1px solid ${colors.tulip_main};
    background: ${colors.tulip_8};
`;
export const AddJoinCommonSuccessBannerContainer = styled(AddJoinCommonBannerContainer) `
    border: 1px solid ${colors.forest_main};
    background: ${colors.forest_8};
`;
export const AddJoinCommonInfoBannerContainer = styled(AddJoinCommonBannerContainer) `
    border: 1px solid ${colors.navy_main};
    background: ${colors.navy_8};
`;
export const AddJoinCommonAlertBannerContainer = styled(FlexRow) `
    padding: 16px;
    gap: 12px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 4px;
    background: ${colors.sunset_main};
`;
export const AddJoinCommonAlertBannerTextContainer = styled(FlexColumn) `
    gap: 8px;
    width: 100%;
`;
export const AddJoinCommonBannerTextContainer = styled(FlexRowSpaceBetween) `
    align-items: top;
    align-self: stretch;
`;
export const AddJoinCommonBannerCloseButton = styled(HXIconButton).attrs({
    children: React.createElement(Close),
}) `
    width: 24px;
    height: 24px;
    color: ${colors.action_light};
`;
export const AddJoinCommonAddAnotherButton = styled(HXButton).attrs({
    startIcon: React.createElement(Add),
    children: "Add another",
    size: "medium",
    text: true,
}) ``;
const formItemCSS = css `
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: ${fontSizes.STANDARD};
    align-self: stretch;
    color: ${colors.black_main};

    & ${HXTextField} {
        width: 100%;
    }
`;
export const FormSectionWithAddButtonContainer = styled(FlexColumn) `
    gap: 24px;
`;
export const FormSection = styled(FlexColumn) `
    gap: 8px;
`;
export const FormItem = styled.label `
    ${formItemCSS}

    ${(props) => props.grow &&
    css `
            flex: 1 0 0;
        `}

    ${(props) => props.width &&
    css `
            width: ${props.width}px;
        `}
`;
export const FormItemDiv = styled.div `
    ${formItemCSS}
`;
export const FormLabel = withExplicitProps(styled.div, "required", "error", "disabled") `
    color: ${colors.black_main};
    font-weight: ${fontWeights.BOLD};
    display: flex;
    align-items: center;
    gap: 4px;

    ${(props) => props.required &&
    css `
            &::after {
                content: " *";
                color: ${colors.tulip_main};
                align-self: normal;
            }
        `}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}

    ${(props) => props.disabled &&
    css `
            color: ${colors.black_30};

            &:after {
                color: ${colors.tulip_30};
            }
        `}
`;
export const NormalFormLabel = styled(FormLabel) `
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const TinyFormLabel = styled(FormLabel) `
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
    font-size: ${fontSizes.TINY};
`;
export const ButtonsContainer = styled(FlexRowDiv) `
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    text-align: left;
    color: ${colors.navy_main};
    font-size: ${fontSizes.STANDARD};
`;
export const ChoiceNavigationContainer = styled(FlexRowDiv) `
    align-items: center;
    justify-content: center;
    text-align: center;
`;
export const ChoiceCounter = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const FormLabelContainer = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const FormLabelMessageContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    gap: 2px;
    color: ${colors.black_lighter};
    font-size: ${fontSizes.TINY};
`;
export const FormLabelMessage = styled.div `
    letter-spacing: 0.4px;
`;
export const StarsAIIcon = styled.img.attrs({ src: aiStarsIcon }) `
    width: ${(props) => { var _a; return (_a = props.width) !== null && _a !== void 0 ? _a : "24px"; }};
    height: ${(props) => { var _a; return (_a = props.width) !== null && _a !== void 0 ? _a : "24px"; }};
`;
const AIClearButtonIcon = styled(Close) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
`;
export const AIClearButton = styled(HXIconButton).attrs({ children: React.createElement(AIClearButtonIcon) }) `
    padding: 0;
`;
export const TooltipUnorderedList = styled.ul `
    margin-bottom: 0;
`;
export const AddJoinCommonIndentedRadioGroup = styled(RadioGroup) `
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 4; }}px;
    align-self: flex-start;

    & .MuiFormControlLabel-root {
        margin-left: 0px; // remove default styling of -11px
    }
`;
export const AddJoinCommonFormRowWithDelete = styled(FlexRow) `
    gap: 8px;
    align-items: center;
`;
const AddJoinCommonDeleteRowIcon = styled(DeleteOutlineOutlined) `
    width: 24px;
    height: 24px;
`;
export const AddJoinCommonDeleteRowButton = styled(IconButton).attrs({ children: React.createElement(AddJoinCommonDeleteRowIcon) }) `
    color: ${colors.black_lighter};
    align-self: center;
`;
export const AddJoinCommonRadioButton = styled(HXRadioButton) `
    ${(props) => props.stretch &&
    css `
            align-self: stretch;
        `}
    height: 32px;
`;
export const IndentedRadioGroupContainer = styled(FlexColumnDiv) `
    margin-bottom: 8px;
    align-items: start;
`;
export const IndentedRadioGroup = styled(RadioGroup) `
    & .MuiFormControlLabel-root {
        margin-left: 0px; // remove default styling of -11px
    }
`;
export const HXFormControlLabel = styled(FormControlLabel) `
    ${(props) => props.error &&
    css `
            .MuiSvgIcon-root {
                color: ${colors.tulip_main};
            }

            .MuiFormControlLabel-label {
                color: ${colors.tulip_main};
            }
        `}
`;
export const AddJoinCommonCFRRequiredCheckbox = styled(HXCheckbox) `
    .MuiFormControlLabel-label.Mui-disabled {
        color: ${colors.black_main};
    }
`;
export const AddJoinCommonTooltipUnorderedList = styled.ul `
    margin-bottom: 0;
`;
const AddJoinCommonAIClearButtonIcon = styled(CloseIcon) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
`;
export const AddJoinCommonAIClearButton = styled(HXIconButton).attrs({ children: React.createElement(AddJoinCommonAIClearButtonIcon) }) `
    padding: 0;
`;
export const ProgressBarWrapper = styled(FlexRow) `
    gap: 32px;
`;
export const ProgressBarLabelText = styled(Text) `
    flex: 0 0 33%;
`;
export const ProgressBarContainer = styled.div `
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
`;
export const ProgressBarBackground = styled.div `
    position: absolute;
    height: 6px;
    width: 100%;
    border-radius: 4px;
    background: ${(props) => props.backgroundColor};
    opacity: 0.2;
`;
export const ProgressBarContent = styled.div `
    position: absolute;
    height: 6px;
    width: ${(props) => props.width}%;
    border-radius: 4px;
    background: ${(props) => props.backgroundColor};
`;
export const WarningIcon = styled(WarningAmberOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.sunset_main};
`;
export const AlertWarningIcon = styled(WarningIcon) `
    width: 24px;
    height: 24px;
    color: ${colors.black_main};
`;
const statusColors = {
    warning: {
        border: colors.sunset_main,
        background: colors.sunset_8,
    },
    info: {
        border: colors.navy_main,
        background: colors.navy_8,
    },
    default: {
        border: colors.navy_main,
        background: colors.navy_8,
    },
};
export const FixedWidthButton = styled(HXButton) `
    min-width: 190px;
    white-space: nowrap;
`;
export const ConfirmUnreviewedContentBanner = styled(FlexRow) `
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${colors.sunset_main};
    background: ${colors.sunset_8};
`;
export const AlertDialogTextParent = styled(FlexRowDiv) `
    gap: 16px;
    align-items: center;
`;
export const AlertDialogTextImage = styled.img.attrs({ src: alertDangerIcon }) `
    width: 90px;
    height: 90px;
`;
export const PDFDownloadButtonCircularProgress = styled(CircularProgress) `
    color: ${colors.navy_main};
    width: 16px;
    max-width: 16px;
    min-width: 16px;
    height: 16px;
    max-height: 16px;
    min-height: 16px;
    margin-right: 4px;
`;
export const PDFDownloadStyledButton = styled(HXButton) ``;
export const TopBannerContainer = styled(FlexRow) `
    position: sticky;
    top: 0;
    z-index: 3;
    width: 100%;
    box-sizing: border-box;
    gap: 16px;
    padding: 6px 40px;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${({ status }) => statusColors[status !== null && status !== void 0 ? status : "default"].border};
    background: ${colors.white_main};

    &:before {
        content: "";
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: ${({ status }) => statusColors[status !== null && status !== void 0 ? status : "default"].background};
    }
`;
export const TopBannerInfoContainer = styled(FlexRow) `
    align-items: center;
    gap: 12px;
    flex: 1 0 0;
    z-index: 2;
`;
export const TopBannerText = styled(Text) `
    padding: 8px 0;
`;
export const TopBannerInfoIcon = styled(InfoOutlined) `
    width: 24px;
    height: 24px;
`;
export const TopBannerWarningIcon = styled(WarningIcon) ``;
export const AddStudyInformedConsentPageParent = styled(FlexColumnDiv) `
    gap: 32px;
`;
export const AddStudyInformedConsentPageHeaderContainer = styled(FlexColumnDiv) `
    gap: 24px;
`;
export const AddStudyInformedConsentPageNavContainer = styled(FlexColumn) `
    padding: 24px;
    gap: 16px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.navy_8};
`;
export const AddStudyInformedConsentPageNavButton = styled(HXButton).attrs({ endIcon: React.createElement(ChevronRight), text: true }) `
    height: 28px;
`;
export const AddStudyInformedConsentPageSectionContainer = styled(FlexColumn) `
    position: relative;
    padding: 24px;
    gap: 16px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
`;
export const AddStudyInformedConsentPageSectionContainerElement = ScrollElement(AddStudyInformedConsentPageSectionContainer);
export const AddStudyInformedConsentScrollToAnchor = styled.div `
    position: absolute;
    width: 0;
    height: 0%;
    left: 0;
    top: -16px;

    ${(props) => props.offSetScrollTo &&
    css `
            top: ${-(props.offSetScrollTo + 16)}px;
        `}
`;
export const AddStudyInformedConsentPageSectionHeaderContainer = styled(FlexRow) `
    gap: 80px;
    align-items: center;
`;
export const AddStudyInformedConsentPageSectionHeaderTextContainer = styled(FlexColumnDiv) `
    gap: 8px;
    flex: 1 0 0;
`;
export const AddStudyInformedConsentPageSectionHeaderText = styled(SemiBoldText) `
    color: ${colors.black_30};
`;
export const AddStudyInformedConsentPageSectionFieldsContainer = styled(FlexColumn) `
    gap: 32px;
`;
export const AddStudyDatePickerPlaceholderTextField = styled(HXTextField) ``;
export const AddStudyDatePickerAdornment = styled(InputAdornment) `
    position: relative;
    width: 24px;
    height: 24px;
`;
export const AddStudyDatePickerHiddenTextField = styled(HXTextField).attrs({ type: "date" }) `
    position: absolute;
    display: block;
    width: 1px;
    height: 1px;
    opacity: 0;

    & .MuiInputBase-formControl {
        left: -180px;
        top: -180px;
    }
`;
const CalendarTodayIcon = styled(CalendarToday) `
    width: 16px;
    height: 16px;
`;
export const AddStudyDatePickerButton = styled(HXIconButton).attrs({
    children: React.createElement(CalendarTodayIcon),
}) ``;
export const LeftIndentedSection = styled(FlexColumn) `
    gap: 16px;
`;
export const LeftIndentedSectionContent = styled(FlexColumn) `
    padding-left: 24px;
    gap: 32px;
`;
export const SubSection = styled(FlexColumn) `
    gap: 16px;
`;
export const SubHeadingSection = styled(FlexColumn) `
    gap: 4px;
`;
export const Heading1 = styled(BoldText) `
    font-size: ${fontSizes.MEDIUM};
    letter-spacing: 0.15px;
`;
export const RadioButtonRow = styled(FlexRow) `
    align-items: center;
    gap: 16px;
`;
export const WizardCircularProgressContainer = styled(FlexColumn) `
    height: 160px;
    padding-top: 8px;
    align-items: center;
    align-self: stretch;
    flex: 1 0 0;
`;
export const WizardCircularProgressProgressContainer = styled.div `
    position: relative;
    z-index: 0;
    outline-color: ${colors.sunset_8};
    outline-style: solid;
    outline-width: 18px;
    outline-offset: -18px;
    border-radius: 100px;
    width: 160px;
    height: 160px;
`;
export const WizardCircularProgressStyle = styled(CircularProgress).attrs({ variant: "determinate" }) `
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    color: ${(props) => (props.succeeded ? colors.forest_main : colors.sunset_main)};
`;
export const WizardCircularProgressText = styled(LightSemiBoldText) `
    position: absolute;
    font-size: ${fontSizes.GIANT};
    letter-spacing: normal;
    left: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
`;
export const WizardCircularProgressErrorIcon = styled(ErrorOutline) `
    width: 160px;
    height: 160px;
    color: ${colors.sunset_main};
`;
export const ProgressChipStyled = styled(Chip) `
    border: 1px solid ${colors.navy_main};
    background: ${colors.navy_8};
    color: ${colors.black_light};
    font-size: ${fontSizes.SMALL};
    line-height: 100%;
    ${(props) => props.completed &&
    css `
            border: 1px solid ${colors.forest_main};
            background: ${colors.forest_12};
        `};
`;
const BaseTranslationColumn = css `
    padding: 0px 16px 24px 16px;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
`;
const BaseTranslationLeftColumn = css `
    border-right: 1px solid ${colors.black_12};
    background: ${colors.white_background};
`;
const BaseTranslationRightColumn = css `
    background: ${colors.white_main};
`;
export const AddStudyInformedConsentTranslationSectionContainer = styled(FlexColumn) `
    /* width: 806px; */
    align-items: flex-start;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
`;
export const AddStudyInformedConsentTranslationSectionStatusContainer = styled(FlexRowSpaceBetween) `
    padding: 16px;
    align-items: center;
    border-bottom: 1px solid ${colors.black_12};
    background: ${colors.tulip_8};

    ${(props) => props.outdated &&
    css `
            background: ${colors.sunset_8};
        `};
`;
export const AddStudyInformedConsentTranslationSectionTitleContainer = styled(FlexRow) `
    padding: 16px;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid ${colors.black_12};
`;
export const AddStudyInformedConsentTranslationSectionLanguageRow = styled(FlexRow) `
    align-items: center;
`;
const BaseAddStudyInformedConsentTranslationSectionLanguageRowColumn = css `
    flex: 1 0 0;
    /* height: 60px; */
    padding: 16px 16px 24px 16px;
    align-items: center;
`;
export const AddStudyInformedConsentTranslationSectionLanguageRowLeftColumn = styled(FlexRowDiv) `
    ${BaseAddStudyInformedConsentTranslationSectionLanguageRowColumn}
    ${BaseTranslationLeftColumn}
    justify-content: space-between;
`;
export const AddStudyInformedConsentTranslationSectionLanguageRowRightColumn = styled(FlexRowSpaceBetween) `
    ${BaseTranslationRightColumn}
    ${BaseAddStudyInformedConsentTranslationSectionLanguageRowColumn}
`;
export const AddStudyInformedConsentTranslationSectionLanguageLockIcon = styled(Lock) `
    color: ${colors.black_light};
    width: 20px;
    height: 20px;
`;
export const AddStudyInformedConsentTranslationSectionLanguageEditIcon = styled(Edit) `
    color: ${colors.navy_main};
    width: 20px;
    height: 20px;
`;
export const AddStudyInformedConsentTranslationSectionLanguageEditButton = styled(HXButton).attrs({
    startIcon: React.createElement(AddStudyInformedConsentTranslationSectionLanguageEditIcon),
    text: true,
}) ``;
export const AddStudyInformedConsentTranslationSectionLanguageFormSectionLeftColumn = styled(FlexColumn) `
    ${BaseTranslationColumn}
    ${BaseTranslationLeftColumn}
`;
export const AddStudyInformedConsentTranslationSectionLanguageFormSectionRightColumn = styled(FlexColumn) `
    ${BaseTranslationColumn}
    ${BaseTranslationRightColumn}
`;
export const AddStudyInformedConsentTranslationSectionLanguageBoldText = styled(BoldText) `
    line-height: 24px;
`;
export const AddJoinCommonOverviewSubNavItemRequired = styled.span `
    &:after {
        color: ${colors.tulip_main};
        content: "*";
    }
`;
export const StudyRequirementTitle = styled(SemiBoldText) `
    max-width: 280px;
    min-width: 280px;
`;
export const AddJoinCommonHeaderButtonsContainer = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
`;
